import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-neutral-50" data-id="element-241">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-242">
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-243">
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="currentColor" data-id="element-244" />
        </svg>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-245">
        <div className="max-w-4xl mx-auto text-center" data-id="element-246">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-247">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-primary text-sm font-medium mb-6 border border-blue-100" data-id="element-248">
              <span className="relative flex h-2 w-2" data-id="element-249">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75" data-id="element-250"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-accent" data-id="element-251"></span>
              </span>
              Est. 2024 — Built on Decades of Expertise
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 tracking-tight mb-6 leading-tight" data-id="element-252">
              Your New Partner in <br className="hidden md:block" data-id="element-253" />
              <span className="text-primary" data-id="element-254">Precision Injection Molding</span>
            </h1>

            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-255">
              Specializing in medical, dental, dietary and food packaging
              solutions. We combine fresh energy with deep industry expertise to
              deliver parts that meet the strictest standards.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-256">
              <Button variant="primary" size="lg" rightIcon={<ArrowRight className="h-4 w-4" data-id="element-258" />} onClick={() => document.getElementById('process')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-257">
                Explore Our Process
              </Button>
              <Button variant="outline" size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-259">
                Discuss Your Project
              </Button>
            </div>

            <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm font-medium text-gray-500" data-id="element-260">
              <div className="flex items-center gap-2" data-id="element-261">
                <CheckCircle2 className="h-4 w-4 text-accent" data-id="element-262" />
                <span data-id="element-263">Medical & Dental Devices</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-264">
                <CheckCircle2 className="h-4 w-4 text-accent" data-id="element-265" />
                <span data-id="element-266">Dietary Supplement Packaging</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-267">
                <CheckCircle2 className="h-4 w-4 text-accent" data-id="element-268" />
                <span data-id="element-269">ISO Compliant Process</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}